import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m4.814-17.889A.5.5 0 0 1 17 5.5V15c0 .37-.07.86-.363 1.297-.304.454-.809.792-1.555.908-.768.119-1.42 0-1.88-.402-.459-.4-.623-.986-.623-1.57 0-.415.199-.774.451-1.056a3.5 3.5 0 0 1 .962-.723A5.7 5.7 0 0 1 16 12.835V9.17l-6 1.366V16c0 .848-.238 1.438-.647 1.84-.388.383-.875.536-1.206.638-.43.132-1.033.153-1.55-.163-.55-.336-.878-.973-.878-1.894 0-1.084.74-1.704 1.496-2.048.58-.265 1.246-.405 1.785-.493V7a.5.5 0 0 1 .395-.489l7-1.5a.5.5 0 0 1 .42.1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandMusicItunes = { render };
export {
  brandMusicItunes as default,
  render
};
//# sourceMappingURL=brand-music-itunes.svg.js.map
